import React from 'react';
import { useTranslation } from 'react-i18next';

export default function Cookies() {
  const { t } = useTranslation();
  const openPreferences = () => {
    window.dispatchEvent(new CustomEvent('open-cookie-preferences'));
  };
  return (
    <section className="section-pad">
      <div className="container-zt" style={{ maxWidth: 860 }}>
        <div className="eyebrow">Zantravina · Legal</div>
        <h1 className="font-display" style={{ fontSize: 'clamp(36px, 5vw, 60px)', lineHeight: 1.05, marginTop: 12 }}>{t('cookies.title')}</h1>
        <p style={{ marginTop: 12, color: 'var(--stone)', fontSize: 14 }}>{t('cookies.updated')}</p>
        <div className="legal-doc" style={{ marginTop: 32 }}>
          <p>{t('cookies.intro')}</p>
          {[1,2,3,4,5,6,7,8].map((i) => (
            <div key={i}>
              <h2>{t(`cookies.s${i}Title`)}</h2>
              <p>{t(`cookies.s${i}Text`)}</p>
            </div>
          ))}
          <div style={{ marginTop: 32 }}>
            <button className="btn btn-primary" onClick={openPreferences} data-testid="open-prefs">{t('cookie.manage')}</button>
          </div>
        </div>
      </div>
    </section>
  );
}
